module.exports = __webpack_public_path__ + "media/images/pro_subscription/partnership/partenariat3-417e3c4eedf3ea948ce22fec6021c96e.jpg";